import React from "react";
import OmanBloreMain from "./OmanBloreMain";
import UaeBloreHead from "../../UaeAttestation/UaeBlore/UaeBloreHead";
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";
const OmanBlore = () => {
  return (
    <div className="uaeBloreContainer">
      <UaeBloreHead head="Oman Apostille in Bangalore" />
      <OmanBloreMain />
    </div>
  );
};

export default OmanBlore;
